// footer-reveal.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function initFooterReveal() {
  const footer = document.querySelector(".footer");
  const main = document.querySelector("main");

  console.log("HOLA");
  if (!footer || !main) return;

  const elements = gsap.utils.toArray(
    ".footer__pre, .footer__titulo, .footer__link, .footer__copyright",
  );

  if (!elements.length) return;

  // Layout
  const setHeight = () => {
    main.style.marginBottom = footer.offsetHeight - 120 + "px";
  };

  setHeight();
  window.addEventListener("resize", () => {
    setHeight();
    ScrollTrigger.refresh();
  });

  // Animación
  gsap.set(elements, { autoAlpha: 0, y: 30 });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: main,
      start: "bottom 40%",
      end: () => `bottom+=${footer.offsetHeight * 0.8} bottom`, // 👈 Después de scrollear la mitad del footer
      scrub: 0.5,
    },
  });

  tl.to(elements, {
    autoAlpha: 1,
    y: 0,
    stagger: 0.08,
    ease: "none",
  });

  // Refresh cuando todo esté listo
  ScrollTrigger.addEventListener("refreshInit", setHeight);
}

export function initDvdBounce(container) {
  const el = container.querySelector(".dvd-bounce");
  if (!el) return;
  const img = el.querySelector("img");

  const images = window.MedialozniData?.dvdImages?.length
    ? window.MedialozniData.dvdImages
    : [
        // fallback por si no hay imágenes configuradas
        `${window.location.origin}/wp-content/themes/medialozni/assets/dist/img/dvd-1.png`,
      ];

  let imgIndex = 0;
  let speedX = 1.5;
  let speedY = 1;
  let x = 0;
  let y = 0;

  // Posición inicial aleatoria
  function setInitialPos() {
    const bounds = container.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    x = Math.random() * (bounds.width - elRect.width);
    y = Math.random() * (bounds.height - elRect.height);
    gsap.set(el, { x, y });
  }

  setInitialPos();

  function swapImage() {
    imgIndex = (imgIndex + 1) % images.length;
    img.src = images[imgIndex];
  }

  gsap.ticker.add(() => {
    const bounds = container.getBoundingClientRect();
    const elW = el.offsetWidth;
    const elH = el.offsetHeight;

    x += speedX;
    y += speedY;

    let hit = false;

    if (x + elW >= bounds.width || x <= 0) {
      speedX *= -1;
      x = x <= 0 ? 0 : bounds.width - elW;
      hit = true;
    }

    if (y + elH >= bounds.height || y <= 0) {
      speedY *= -1;
      y = y <= 0 ? 0 : bounds.height - elH;
      hit = true;
    }

    if (hit) swapImage();

    gsap.set(el, { x, y });
  });
}
